module.exports = __webpack_public_path__ + "static/img/dw_loginbg.dcc9422.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dw_loginbg.jpg
// module id = zkyf
// module chunks = 194